import { type ReactNode, type HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'glass' | 'dark';
  children: ReactNode;
}

export function Card({ variant = 'default', children, className = '', ...props }: CardProps) {
  const variants = {
    default: 'bg-white border border-[#EFEAE2]',
    glass: 'glass-card',
    dark: 'bg-neutral-900 text-white',
  };

  return (
    <div
      className={`rounded-2xl shadow-[0_1px_4px_rgba(0,0,0,0.06)] ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function CardHeader({ children, className = '', ...props }: CardHeaderProps) {
  return (
    <div className={`border-b border-[#F0EDE8] p-6 ${className}`} {...props}>
      {children}
    </div>
  );
}

interface CardContentProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function CardContent({ children, className = '', ...props }: CardContentProps) {
  return (
    <div className={`p-6 ${className}`} {...props}>
      {children}
    </div>
  );
}

interface CardFooterProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function CardFooter({ children, className = '', ...props }: CardFooterProps) {
  return (
    <div className={`border-t border-[#F0EDE8] p-6 ${className}`} {...props}>
      {children}
    </div>
  );
}
